const getWebviewDashboardUrl = (courseRunKey: string) =>
  `edxapp://enrolled_course_info?course_id=${courseRunKey}`;

export default getWebviewDashboardUrl;
